import { getSpotifyEmbedUrl, isSoundCloudUrl } from "@/lib/media-utils";

interface AudioEmbedProps {
  url: string;
}

const AudioEmbed = ({ url }: AudioEmbedProps) => {
  const spotifyEmbed = getSpotifyEmbedUrl(url);

  if (spotifyEmbed) {
    return (
      <div className="w-full rounded-lg overflow-hidden">
        <iframe
          src={spotifyEmbed}
          width="100%"
          height="152"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          className="rounded-lg"
        />
      </div>
    );
  }

  if (isSoundCloudUrl(url)) {
    return (
      <div className="w-full rounded-lg overflow-hidden">
        <iframe
          width="100%"
          height="166"
          scrolling="no"
          allow="autoplay"
          src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%23D2691E&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`}
          className="rounded-lg"
        />
      </div>
    );
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="text-accent hover:underline font-typewriter">
      Listen to this episode →
    </a>
  );
};

export default AudioEmbed;
